import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { CountryName } from '../../../../assets/functions/get-country-name';
import { OnlyAcceptNumbers } from '../../../../assets/functions/only-accept-numbers';
import { StatusProduct } from '../../../models/enum/status-product';
import { ProductEdit } from '../../../models/product/product-edit';
import { ApsPermissionService } from '../../../services/aps-permission/aps-permission.service';
import { ProductService } from '../../../services/product/product.service';
import { RateCurveService } from '../../../services/rate-curve/rate-curve.service';
import { RateCurve } from '../../../models/rate-curve/rate-curve';
import { ProductCreateUpdateDto } from 'src/app/models/product/product-create-update';
import { RateCurveProduct } from 'src/app/models/rate-curve/rate-curve-product';

type DropdownChangeEvent<T> = {
  value: T;
};

@Component({
  selector: 'app-product-details-edit',
  templateUrl: './product-details-edit.component.html',
  styleUrls: ['./product-details-edit.component.scss'],
  providers: [DatePipe] //DatePipe como provider
  ,
  standalone: false
})
export class ProductDetailsEditComponent implements OnInit, AfterViewInit {
  private readonly destroyRef = inject(DestroyRef);

  inputProductName: string | undefined = '';
  inputProductDescription: string | undefined = '';
  inputProductStatus: string | undefined = '';
  inputProductVisit: number | undefined = 0;
  inputProductMonths: number | undefined = 0;
  inputProductDistance: number | undefined = 0;
  inputProductCode: string | undefined = '';
  inputProductAccountCode: string | undefined = '';
  inputProductActionCode: string | undefined = '';
  inputProductCoverageCode: string | undefined = '';
  inputProductInsuranceCode: string | undefined = '';
  inputProductProductDetails: string | undefined = '';
  inputProductInvoiceMonths: number | undefined = 0;
  inputProductDistanceDisplay: string = '';

  actionCodeUppercase: string = '';
  accountCodeUppercase: string = '';
  coverageUppercase: string = '';
  insuranceCodeUppercase: string = '';
  id: number = 0;
  product: ProductEdit = {} as ProductEdit;
  editedProduct: ProductCreateUpdateDto = {} as ProductCreateUpdateDto;
  blockedUi = false;
  selectedStatus: StatusProduct | undefined;
  selectDisabled = true;
  productCreationDateformat: string = '';
  countryNameResult: string = '';
  editionEnabled = true;
  isEditingMode = false;
  hasAttemptedSave = false;

  rateCurves: RateCurve[] = [];
	allRateCurves: RateCurve[] = [];
	rateCurve!: RateCurve;
  rateCurveProduct: RateCurveProduct = new RateCurveProduct();
	placeholderRateCurve = 'TRANSLATE.SELECT';
	selectedRateCurveId: number | null = null;

  listStatus = [
    { label: 'TRANSLATE.SELECT' },
    { label: 'TRANSLATE.ACTIVE', value: StatusProduct.ACTIVE },
    { label: 'TRANSLATE.INACTIVE', value: StatusProduct.INACTIVE }
  ];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private productService: ProductService,
    private apsPermissionService: ApsPermissionService,
    private messageService: MessageService,
    public translateService: TranslateService,
    private datePipe: DatePipe,
    private countryName: CountryName,
    private onlyAcceptNumbers: OnlyAcceptNumbers,
    private rateCurveService: RateCurveService
  ) {

    this.route.paramMap.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(params => {
      const id = params.get('id');
      this.id = id ? +id : 0;
    });
  }

  ngOnInit() {
    this.blockedUi = true;
    this.searchProduct(this.id);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.buttonCancel();
    }, 0);
  }

  buttonReturn() {
    this.router.navigate(['view-plans'], { skipLocationChange: false, replaceUrl: false });
  }

  buttonEdit() {
    this.isEditingMode = true;
    this.hasAttemptedSave = false;
    this.clearValidationState();

    this.selectDisabled = false;
    (document.getElementById("productName") as HTMLInputElement).disabled = false;
    (document.getElementById("productStatus") as HTMLInputElement).disabled = false;
    (document.getElementById("productCode") as HTMLInputElement).disabled = false;
    (document.getElementById("visit") as HTMLInputElement).disabled = false;
    (document.getElementById("months") as HTMLInputElement).disabled = false;
    (document.getElementById("distance") as HTMLInputElement).disabled = false;
    (document.getElementById("productDescription") as HTMLInputElement).disabled = false;
    (document.getElementById("account") as HTMLInputElement).disabled = false;
    (document.getElementById("actionCode") as HTMLInputElement).disabled = false;
    (document.getElementById("coverageCode") as HTMLInputElement).disabled = false;
    (document.getElementById("insuranceCode") as HTMLInputElement).disabled = false;
    (document.getElementById("productDetails") as HTMLInputElement).disabled = false;
    (document.getElementById("titleDetails") as HTMLInputElement).style.display = 'none';
    (document.getElementById("titleEdit") as HTMLInputElement).style.display = 'block';
    (document.getElementById("subTitle") as HTMLInputElement).style.display = 'block';

  }

  buttonCancel() {
    this.isEditingMode = false;
    this.hasAttemptedSave = false;
    this.clearValidationState();

    this.selectDisabled = true;
    (document.getElementById("productName") as HTMLInputElement).disabled = true;
    (document.getElementById("productStatus") as HTMLInputElement).disabled = true;
    (document.getElementById("productCode") as HTMLInputElement).disabled = true;
    (document.getElementById("visit") as HTMLInputElement).disabled = true;
    (document.getElementById("months") as HTMLInputElement).disabled = true;
    (document.getElementById("distance") as HTMLInputElement).disabled = true;
    (document.getElementById("productDescription") as HTMLInputElement).disabled = true;
    (document.getElementById("account") as HTMLInputElement).disabled = true;
    (document.getElementById("actionCode") as HTMLInputElement).disabled = true;
    (document.getElementById("coverageCode") as HTMLInputElement).disabled = true;
    (document.getElementById("insuranceCode") as HTMLInputElement).disabled = true;
    (document.getElementById("productDetails") as HTMLInputElement).disabled = true;
    (document.getElementById("titleDetails") as HTMLInputElement).style.display = 'block';
    (document.getElementById("titleEdit") as HTMLInputElement).style.display = 'none';
    (document.getElementById("subTitle") as HTMLInputElement).style.display = 'none';

    this.searchProduct(this.id);

  }

  private clearValidationState() {
    this.inputProductName = undefined;
    this.inputProductDescription = undefined;
    this.inputProductStatus = undefined;
    this.inputProductVisit = undefined;
    this.inputProductMonths = undefined;
    this.inputProductDistance = undefined;
    this.inputProductCode = undefined;
    this.inputProductAccountCode = undefined;
    this.inputProductActionCode = undefined;
    this.inputProductCoverageCode = undefined;
    this.inputProductInsuranceCode = undefined;
    this.inputProductProductDetails = undefined;
    this.editionEnabled = true;
  }

  accountOnKeyUp(event: Event) {
    this.accountCodeUppercase = (event.target as HTMLInputElement).value.toUpperCase();
  }

  actionCodeOnKeyUp(event: Event) {
    this.actionCodeUppercase = (event.target as HTMLInputElement).value.toUpperCase();
  }

  coverageCodeOnKeyUp(event: Event) {
    this.coverageUppercase = (event.target as HTMLInputElement).value.toUpperCase();
  }

  insuranceCodeOnKeyUp(event: Event) {
    this.insuranceCodeUppercase = (event.target as HTMLInputElement).value.toUpperCase();
  }

  statusChange(event: DropdownChangeEvent<StatusProduct | undefined>) {
    this.selectedStatus = typeof event.value === 'number' ? event.value : undefined;
  }

  visit(visit: Event) {
    this.inputProductVisit = this.onlyAcceptNumbers.formatNumber(visit);
  }

  monthsProduct(months: Event) {
    const digitsOnlyValue = this.formatNumberWithMaxDigits(months, 3);
    this.inputProductMonths = digitsOnlyValue === '' ? undefined : Number(digitsOnlyValue);
    this.product.months = this.inputProductMonths;
  }

  distance(distance: Event) {
    const formattedValue = this.formatDistanceNumber(distance, 6);
    this.inputProductDistanceDisplay = formattedValue;
    this.inputProductDistance = formattedValue === '' ? undefined : Number(this.normalizeDigitsOnly(formattedValue));
  }

  private formatNumberWithMaxDigits(event: Event, maxDigits: number): string {
    const input = event.target as HTMLInputElement;
    const digitsOnlyValue = input.value.replace(/\D/g, '').slice(0, maxDigits);

    input.value = digitsOnlyValue;
    return digitsOnlyValue;
  }

  private formatDistanceNumber(event: Event, maxDigits: number): string {
    const input = event.target as HTMLInputElement;
    const digitsOnlyValue = input.value.replace(/\D/g, '').slice(0, maxDigits);
    const formattedValue = digitsOnlyValue.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');

    input.value = formattedValue;
    return formattedValue;
  }

  private normalizeDigitsOnly(value: string | number | null | undefined): string {
    return (value ?? '').toString().replace(/\D/g, '');
  }

  private parseRequiredDigitsFieldValue(elementId: string): number | undefined {
    const rawValue = (document.getElementById(elementId) as HTMLInputElement | null)?.value ?? '';
    const normalizedValue = this.normalizeDigitsOnly(rawValue);

    if (normalizedValue === '') {
      return undefined;
    }

    const numericValue = Number(normalizedValue);
    return Number.isNaN(numericValue) ? undefined : numericValue;
  }

  private formatDistanceForDisplay(value: number | null | undefined): string {
    const normalizedValue = this.normalizeDigitsOnly(value);

    if (normalizedValue === '') {
      return '';
    }

    return normalizedValue.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
  }

  buttonSave() {

    this.hasAttemptedSave = true;

    this.blockedUi = true;
    this.editionEnabled = true;

    this.inputProductName = this.normalizeTextValue((document.getElementById("productName") as HTMLInputElement).value);
    this.inputProductStatus = this.selectedStatus !== undefined ? String(this.selectedStatus) : undefined;
    this.inputProductCode = (document.getElementById("productCode") as HTMLInputElement).value;
    this.inputProductDescription = this.normalizeTextValue((document.getElementById("productDescription") as HTMLSelectElement).value);

    this.inputProductAccountCode = (document.getElementById("account") as HTMLInputElement).value;
    this.inputProductActionCode = (document.getElementById("actionCode") as HTMLInputElement).value;
    this.inputProductCoverageCode = (document.getElementById("coverageCode") as HTMLInputElement).value;
    this.inputProductInsuranceCode = (document.getElementById("insuranceCode") as HTMLInputElement).value;
    this.inputProductProductDetails = (document.getElementById("productDetails") as HTMLInputElement).value;
    this.inputProductMonths = this.parseRequiredDigitsFieldValue('months');
    this.inputProductDistance = this.parseRequiredDigitsFieldValue('distance');

    // Insurance Code: required — must not be empty/blank (but 'NULO' → null is allowed)
    const insuranceTrimmed = this.inputProductInsuranceCode?.trim().toUpperCase() ?? '';
    const insuranceIsEmpty = insuranceTrimmed === '';
    if (insuranceIsEmpty) {
      this.inputProductInsuranceCode = undefined;
      this.blockedUi = false;
      this.editionEnabled = false;
    }
    if (!this.inputProductName) {

      this.inputProductName = undefined;
      this.blockedUi = false;
      this.editionEnabled = false;
    } else if (this.inputProductName.length < 4) {

      this.blockedUi = false;
      this.editionEnabled = false;
    }
    if (this.inputProductStatus === null ||
      this.inputProductStatus === undefined) {

      this.inputProductStatus = undefined;
      this.blockedUi = false;
      this.editionEnabled = false;
    }
    if (!this.inputProductCode || this.inputProductCode.length <= 0) {

      this.inputProductCode = undefined;
      this.blockedUi = false;
      this.editionEnabled = false;
    }
    if (this.inputProductInvoiceMonths === undefined) {

      this.inputProductInvoiceMonths = Number((document.getElementById("invoiceMonths") as HTMLInputElement).value);
    }

    if (this.inputProductMonths === undefined || this.inputProductMonths <= 0 || this.inputProductMonths > 999) {

      this.blockedUi = false;
      this.editionEnabled = false;
    }

    if (this.inputProductDistance === undefined || this.inputProductDistance <= 0 || this.inputProductDistance > 999999) {

      this.blockedUi = false;
      this.editionEnabled = false;
    }

    if (this.inputProductVisit === undefined) {

      this.inputProductVisit = Number((document.getElementById("visit") as HTMLInputElement).value);
    }
    if (this.inputProductVisit == null || this.inputProductVisit <= 0 ||
      Number.isNaN(this.inputProductVisit)) {

      this.inputProductVisit = undefined;
      this.blockedUi = false;
      this.editionEnabled = false;
    }
    if (!this.inputProductDescription) {

      this.inputProductDescription = undefined;
      this.blockedUi = false;
      this.editionEnabled = false;
    } else if (this.inputProductDescription.length < 4) {

      this.blockedUi = false;
      this.editionEnabled = false;
    }
    // Insurance Code validation is handled above (insuranceIsEmpty check)

    if (!this.editionEnabled) {
      this.focusFirstInvalidField();
      if (!this.hasProductMinLengthError()) {
        this.messageService.add({
          severity: 'error',
          summary: this.translateService.instant('TRANSLATE.ERROR'),
          detail: this.translateService.instant('TRANSLATE.ERROR.PLEASE.REQUIRED.FIELDS')
        });
      }
      return;
    }

    if (this.editionEnabled) {

      this.editedProduct.id = this.product.id;
      this.editedProduct.name = this.inputProductName!;
      this.editedProduct.statusCode = this.selectedStatus ?? 0;
      this.editedProduct.country = this.product.country;
      this.editedProduct.productCode = this.inputProductCode!;
      this.editedProduct.description = this.inputProductDescription!;
      this.editedProduct.visit = this.inputProductVisit;
      this.editedProduct.months = this.inputProductMonths;
      this.editedProduct.kilometers = this.inputProductDistance;
      this.editedProduct.invoiceMonths = this.inputProductInvoiceMonths;
      this.editedProduct.accountCode = this.nullify(this.inputProductAccountCode);
      this.editedProduct.actionCode = this.nullify(this.inputProductActionCode);
      this.editedProduct.coverageCode = this.nullify(this.inputProductCoverageCode);
      this.editedProduct.insuranceCode = this.inputProductInsuranceCode!;
      this.editedProduct.details = this.inputProductProductDetails;
      this.editedProduct.userId = this.apsPermissionService.getUserCsid();
      this.editedProduct.rateCurveId = this.selectedRateCurveId!;

      this.productService.updateProduct(this.editedProduct)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: () => {

            this.blockedUi = false;
            this.searchProduct(this.editedProduct.id);
            this.buttonCancel();

            this.messageService.add({
              severity: 'success',
              summary: this.translateService.instant('TRANSLATE.SUCCESS'),
              detail: this.translateService.instant('TRANSLATE.SUCCESS.EDIT')
            });
          }, error: (err) => {

            this.blockedUi = false;
            this.searchProduct(this.editedProduct.id);

            if (err.status === 400) {

              this.messageService.add({
                severity: 'error',
                summary: this.translateService.instant('TRANSLATE.ERROR'),
                detail: this.translateService.instant('TRANSLATE.ERROR.PLEASE.REQUIRED.FIELDS')
              });
            } else if (err.status === 404) {

              this.messageService.add({
                severity: 'error',
                summary: this.translateService.instant('TRANSLATE.ERROR'),
                detail: this.translateService.instant('TRANSLATE.ERROR.SAVE.CHANGES')
              });

            } else if (err.status === 401) {

              this.messageService.add({
                severity: 'error',
                summary: this.translateService.instant('TRANSLATE.ERROR'),
                detail: this.translateService.instant('TRANSLATE.USER.WITHOUT.PERMISSION.REFRESH.PAGE')
              });

            } else {

              this.messageService.add({
                severity: 'error',
                summary: this.translateService.instant('TRANSLATE.ERROR'),
                detail: this.translateService.instant('TRANSLATE.ERROR.CONTACT.SYSTEM.ADMINISTRATOR')
              });
            }

          }

        });
    }

  }

  searchProduct(id: number) {

    this.productService.getProductById(id).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(
      (response) => {
        this.product.id = response.id;
        this.product.name = response.name;
        this.product.country = response.country;
        this.countryNameResult = this.countryName.getCountryName(this.product.country);
        this.product.code = response.productCode;
        this.selectedStatus = ((response.productStatus === StatusProduct.ACTIVE) ? StatusProduct.ACTIVE : StatusProduct.INACTIVE);
        this.product.description = response.description;
        this.product.visit = response.visit;
        this.product.months = response.months;
        this.inputProductMonths = response.months;
        this.product.invoiceMonths = response.invoiceMonths;
        this.product.kilometers = response.kilometers;
        this.inputProductDistance = response.kilometers;
        this.product.accountCode = this.deNullify(response.accountNumber);
        this.product.actionCode = this.deNullify(response.actionCode);
        this.product.coverageCode = this.deNullify(response.coverageCode);
        this.product.insuranceCode = this.deNullify(response.insuranceCode);
        this.product.createDate = response.createDate;
        this.productCreationDateformat = this.datePipe.transform(response.createDate, 'dd/MM/yyyy') ?? '';
        this.product.details = response.productDetails;
        this.findRateCurveProduct(this.product.id);
        this.inputProductDistanceDisplay = this.formatDistanceForDisplay(response.kilometers);
        this.blockedUi = false;
      }
    )
  }

  /** Converts null/undefined from API to the display string 'NULO' */
  private deNullify(value: string | null | undefined): string {
    return (value === null || value === undefined) ? 'NULO' : value;
  }

  /** Converts 'NULO' or empty string to null for API persistence */
  private nullify(value: string | null | undefined): string | null {
    if (value === null || value === undefined) return null;
    const trimmed = value.trim().toUpperCase();
    return (trimmed === '' || trimmed === 'NULO') ? null : trimmed;
  }

  private normalizeTextValue(value: string | null | undefined): string {
    return (value ?? '').trim();
  }

  isProductNameEmpty(): boolean {
    return this.isEditingMode && this.hasAttemptedSave && this.normalizeTextValue(this.inputProductName).length === 0;
  }

  isProductNameTooShort(): boolean {
    const value = this.normalizeTextValue(this.inputProductName);
    return this.isEditingMode && this.hasAttemptedSave && value.length > 0 && value.length < 4;
  }

  isProductDescriptionEmpty(): boolean {
    return this.isEditingMode && this.hasAttemptedSave && this.normalizeTextValue(this.inputProductDescription).length === 0;
  }

  isProductDescriptionTooShort(): boolean {
    const value = this.normalizeTextValue(this.inputProductDescription);
    return this.isEditingMode && this.hasAttemptedSave && value.length > 0 && value.length < 4;
  }

  isProductMonthsEmpty(): boolean {
    return this.isEditingMode && this.hasAttemptedSave && this.inputProductMonths === undefined;
  }

  isProductMonthsZeroOrLess(): boolean {
    return this.isEditingMode && this.hasAttemptedSave && this.inputProductMonths !== undefined && this.inputProductMonths <= 0;
  }

  isProductDistanceEmpty(): boolean {
    return this.isEditingMode && this.hasAttemptedSave && this.inputProductDistance === undefined;
  }

  isProductDistanceZeroOrLess(): boolean {
    return this.isEditingMode && this.hasAttemptedSave && this.inputProductDistance !== undefined && this.inputProductDistance <= 0;
  }

  private hasProductMinLengthError(): boolean {
    return this.isProductNameTooShort() || this.isProductDescriptionTooShort();
  }

  private focusFirstInvalidField(): void {
    const fields = [
      { invalid: this.isProductNameEmpty() || this.isProductNameTooShort(), elementId: 'productName' },
      { invalid: this.inputProductStatus === undefined || this.inputProductStatus === null, elementId: 'productStatus' },
      { invalid: this.inputProductCode === undefined || this.inputProductCode === null, elementId: 'productCode' },
      { invalid: this.inputProductVisit === undefined || this.inputProductVisit === null, elementId: 'visit' },
			{ invalid: this.isProductMonthsEmpty() || this.isProductMonthsZeroOrLess(), elementId: 'months' },
			{ invalid: this.isProductDistanceEmpty() || this.isProductDistanceZeroOrLess(), elementId: 'distance' },
      { invalid: this.isProductDescriptionEmpty() || this.isProductDescriptionTooShort(), elementId: 'productDescription' },
      { invalid: this.inputProductInsuranceCode === undefined || this.inputProductInsuranceCode === null, elementId: 'insuranceCode' }
    ];

    const firstInvalidField = fields.find(field => field.invalid);
    if (!firstInvalidField) {
      return;
    }

    this.focusFieldById(firstInvalidField.elementId);
  }

  private focusFieldById(elementId: string): void {
    setTimeout(() => {
      const host = document.getElementById(elementId) as HTMLElement | null;
      if (!host) {
        return;
      }

      const focusableChild = host.querySelector('input, textarea, .p-dropdown-label, .p-multiselect-label, [tabindex]') as HTMLElement | null;
      const target = focusableChild ?? host;

      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      target.focus();
    }, 0);
  }

  private getRateCurvesByCountry(country: string, currentRateCurveId: number | null = null) {

    this.rateCurveService.getRateCurvesByCountry(country)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({

        next: (response: RateCurve[]) => {

          this.rateCurves = response;
          this.allRateCurves = [...response];
          if (this.rateCurves.length > 0) {

            this.selectedRateCurveId = currentRateCurveId;
            this.placeholderRateCurve = 'TRANSLATE.SELECT';
          } else {

            this.placeholderRateCurve = 'TRANSLATE.NO.RESULT.FOUND';
          }
        },
        error: (err) => {

          if (err.status === 404) {

            console.log(`Nenhuma curva encontrada para o país ${country}.`);
            this.placeholderRateCurve = 'TRANSLATE.NO.RESULT.FOUND';
          } else {

            console.error('Erro inesperado ao buscar curvas por país:', err);
            this.placeholderRateCurve = 'TRANSLATE.ERROR.LOADING';
          }
          this.rateCurves = [];
          this.allRateCurves = [];
          this.selectedRateCurveId = null;
        }
      });
  }

  findRateCurveProduct(productId: number) {

    this.rateCurveService.findRateCurveProductByProduct(productId).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe({

      next: (response) => {

        this.rateCurveProduct.rateId = response.rateId;
        this.rateCurveProduct.productId = response.productId;
        this.getRateCurvesByCountry(this.apsPermissionService.getUserCountry(), this.rateCurveProduct.rateId);
      },
      error: (err) => {

        if (err.status === 404) {

          console.log('Nenhuma curva encontrada para esse produto.');
          this.getRateCurvesByCountry(this.apsPermissionService.getUserCountry(), null);
        } else {
          
          console.error('Erro inesperado ao buscar curva:', err);
        }
      }
    });
  }

  rateCurveOnChange(event: any) {

		const selectedId = event.value;
		this.selectedRateCurveId = selectedId;
		this.rateCurve = this.rateCurves.find(rc => rc.rateId === selectedId) || new RateCurve();
	}

}
